export const pendoMixin = {
  props: {
    dataPendo: {
      type: String,
      default: null,
      required: false
    }
  }
}
